import { render, staticRenderFns } from "./Pairassociateslearning.vue?vue&type=template&id=9676066c&scoped=true&"
import script from "./Pairassociateslearning.vue?vue&type=script&lang=js&"
export * from "./Pairassociateslearning.vue?vue&type=script&lang=js&"
import style0 from "./Pairassociateslearning.vue?vue&type=style&index=0&id=9676066c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9676066c",
  null
  
)

export default component.exports